import { render } from "./clerkStatistics.vue?vue&type=template&id=34a84701"
import script from "./clerkStatistics.vue?vue&type=script&lang=js"
export * from "./clerkStatistics.vue?vue&type=script&lang=js"

import "./clerkStatistics.vue?vue&type=style&index=0&id=34a84701&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__